// extracted by mini-css-extract-plugin
export var fullHeightState = "_4c-7";
export var headerCell = "_4c-1";
export var loadingStateCell = "_4c-4";
export var rowWrapper = "_4c-3";
export var standaloneTable = "_4c-8";
export var standaloneTableWithBodyFill = "_4c-9";
export var stateCell = "_4c-5";
export var table = "_4c-0";
export var tableBodyFiller = "_4c-6";
export var white = "_4c-2";